export const TRANSITION_TO_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX = '1';
export const TRANSITION_FROM_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX = '2';
export const TRANSITION_FROM_THE_SALES_FUNNEL_ROBOT_INDEX = '3';
export const TASK_CREATING_ROBOT_INDEX = '4';
export const SET_TAG_ROBOT_INDEX = '5';
export const KEYWORD_MESSAGE_ROBOT_INDEX = '6';
export const SEND_MESSAGE_ROBOT_INDEX = '100';

export const INCOMING_MESSAGE_TRIGGER_TYPE = 'IncomingMessage';

// Единственный триггер робота "Сообщение по ключевым словам" — форма его не выбирает
export const KEYWORD_MESSAGE_TRIGGER_TYPE = INCOMING_MESSAGE_TRIGGER_TYPE;
